import {NgModule} from '@angular/core';
import {Route, RouterModule} from '@angular/router';
import {LayoutComponent} from './layout/layout.component';
import {objectsListRoutes, objectsModuleRoutes} from './objects/objects-routing.module';
import {conclusionListRoutes, conclusionRoutes} from './conclusion/conclusion-routing.module';
import {technicalDeviceRouterForWorkingObject} from './technical-device/technical-device-routing.module';
import {WorkingObjectsPagesResetOnDeactivateService} from './objects/services/working-objects-pages-reset-on-deactivate.service';
import {WorkingObjectsTechnicalDevicePagesResetOnDeactivateService} from './objects/services/working-objects-technical-device-pages-reset-on-deactivate.service';
import {TechnicalDeviceElementGroupsPagesResetOnDeactivateService} from './technical-device/services/element-groups/technical-device-element-groups-pages-reset-on-deactivate.service';
import {TechnicalDeviceElementsPagesResetOnDeactivateService} from './technical-device/services/elements/technical-device-elements-pages-reset-on-deactivate.service';
import {ConclusionPagesResetOnDeactivateService} from './conclusion/services/conclusion-pages/conclusion-pages-reset-on-deactivate.service';
import {elementRoutes} from './element/element-routing.module';
import {elementGroupRoutes} from './element-group/element-group-routing.module';

export const workingObjectsRoutes: Route[] = [
    {
        path: '',
        canDeactivate: [
            ConclusionPagesResetOnDeactivateService,
            WorkingObjectsPagesResetOnDeactivateService,
            WorkingObjectsTechnicalDevicePagesResetOnDeactivateService,
            TechnicalDeviceElementGroupsPagesResetOnDeactivateService,
            TechnicalDeviceElementsPagesResetOnDeactivateService,
        ],
        children: [
            {
                path: '',
                component: LayoutComponent,
                resolve: {

                },
                /**
                 * Тут списочные страницы и соответствующие им роуты
                 */
                children: [
                    {
                        path: '',
                        children: objectsListRoutes,
                    },
                    {
                        path: 'conclusions',
                        children: conclusionListRoutes,
                    }
                ]
            },
            {
                path: '',
                children: objectsModuleRoutes,
            },
            {
                path: 'conclusions',
                children: conclusionRoutes,
            },
            {
                path: 'technical-device',
                children: technicalDeviceRouterForWorkingObject,
            },
            {
                path: 'element',
                children: elementRoutes,
            },
            {
                path: 'element-group',
                children: elementGroupRoutes,
                data: {
                    title: 'Типоразмер элемента'
                }
            }
        ]
    },
];

@NgModule({
    imports: [
        RouterModule.forChild(workingObjectsRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class WorkingObjectsRoutingModule {
}
